// extracted by mini-css-extract-plugin
module.exports = {"pillSection":"_2nSHuW8H"};